import React, { useEffect } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableHeader,
    TableRow,
} from "../ui/table";

interface CsvPreviewProps {
    data: Record<string, string>[];
    onClose: () => void;
    fileName: string;
}

const CsvPreview: React.FC<CsvPreviewProps> = ({ data, onClose, fileName }) => {
    // Get headers (column names) from the data

    const dataAsArray = Object.values(data);
    const row0 = dataAsArray[0];

    //const parsedData = JSON.parse(data);
    const headers = Object.keys(dataAsArray[0]);

    const rowCount = Object.keys(data).length;
    const keys = Object.keys(data);

    // Handle escape key press
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onClose();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);

    return (
        <div className="fixed inset-0 bg-black/50 dark:bg-black/70 z-[100] flex items-center justify-center p-4">
            <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-6xl max-h-[90vh] flex flex-col">
                <div className="p-4 border-b dark:border-gray-700 flex justify-between items-center">
                    <h2 className="text-xl font-semibold dark:text-white">{fileName} - Preview</h2>
                    <button
                        onClick={onClose}
                        className="rounded-full p-2 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-gray-300"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>

                <div className="p-4 overflow-auto flex-grow dark:text-gray-200">
                    {headers.length > 0 ? (
                        <Table className="dark:border-gray-700">
                            <TableHeader className="dark:bg-gray-900">
                                <TableRow className="dark:border-gray-700">
                                    {headers.map((header) => (
                                        <TableCell key={header} className="dark:text-gray-300">{header}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {Array.from({ length: rowCount }).map((_, rowIndex) => (
                                    <TableRow key={rowIndex} className="dark:border-gray-700 dark:hover:bg-gray-900">
                                        {headers.map((header) => (
                                            <TableCell key={`${header}-${rowIndex}`} className="dark:text-gray-300">
                                                {dataAsArray[rowIndex][header] || ''}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    ) : (
                        <div className="text-center py-8 dark:text-gray-300">No data available</div>
                    )}
                </div>

                <div className="p-4 border-t dark:border-gray-700 flex justify-end">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-200 dark:bg-gray-700 dark:text-gray-200 rounded hover:bg-gray-300 dark:hover:bg-gray-600"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CsvPreview; 